import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cs0007',
    ecrans: ['00-2'],
    params: ['id', '?viccleint']
});
